module.exports = __webpack_public_path__ + "img/symbol_4.1a74d4da.png";